module.exports = __webpack_public_path__ + "static/media/snap-logo.4fa9b28a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/snap-logo.png
// module id = 693
// module chunks = 0